import React, { Component } from "react";
import './PrivacyPolicy.css';
import Container from "../../components/Container";
import Sidebar from "../../components/Sidebar";

class PrivacyPolicy extends Component {
  render() {
    return (
      <Container backgroundColor="#ffffff">
        <div className="page-sidebar privacy-policy">
          <div>
            <h1>Privacy Policy</h1>
            <div className="privacy-policy-text">
              <h2>Site Disclaimer</h2>
              <p>Any use of this website or the information contained in the website is at your own risk. We will not be responsible for the consequences of your decision to utilize the information contained in this website.</p>
              <p>The medical information provided in this site is for educational purposes only, it is not intended nor implied to be a substitute for professional medical advice. Always consult your physician or healthcare provider prior to starting any new treatment or with any questions you may have regarding a medical condition.</p>
            </div>
            <div className="privacy-policy-text">
              <h2>Privacy Policy</h2>
              <p>We are committed to the right to privacy for our patients and web site visitors. When a person visits our web site we may collect and track data from our site's server. This information helps us to improve upon the content provided on our site. Information collected may include how long you spend on our site, the pages you visit, your browser and operating system types and the name of your Internet service provider.</p>
              <p>Our web site provides the capability to request information on-line. To process your request, we may require that you provide us with personal identifying information. All information collected is held in complete confidence. It is our policy not to share the information with third parties for any reason, unless legally required to do so or as necessary to process your requests (for further details, please refer to Patient Rights and/or call our office.</p>
              <p>If you have any questions about our privacy policy or our use of information gathered through our web site, please contact us at (402)932-2248</p>
            </div>
          </div>
          <Sidebar />
        </div>
      </Container>
    );
  }
}

export default PrivacyPolicy;